import { render, staticRenderFns } from "./ResetPage.vue?vue&type=template&id=fc807010&scoped=true"
import script from "./ResetPage.vue?vue&type=script&lang=js"
export * from "./ResetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc807010",
  null
  
)

export default component.exports